if (!customElements.get('testimonials-slider')) {
  customElements.define(
    'testimonials-slider',
    class TestimonialsSlider extends HTMLElement {
      connectedCallback() {
        this.sliderElement = this.querySelector('[data-testimonials-slider]');
        this.previousButtonElement = this.querySelector('[data-testimonials-previous]');
        this.nextButtonElement = this.querySelector('[data-testimonials-next]');
        this.dotElements = [...this.querySelectorAll('[data-testimonials-dot]')];
        this.quoteElements = [...this.querySelectorAll('[data-testimonials-quote]')];

        this.initReadMore();

        if (!this.sliderElement || !window.T4SThemeSP?.Carousel) return;

        this.initSlider();
      }

      disconnectedCallback() {
        this.quoteResizeObserver?.disconnect();
      }

      initReadMore() {
        if (!this.quoteElements.length) return;

        this.quoteElements.forEach(quoteElement => {
          const readMoreButtonElement = this.getReadMoreButtonElement(quoteElement);
          readMoreButtonElement?.addEventListener('click', () => this.toggleQuote(quoteElement));
        });

        this.quoteResizeObserver = new ResizeObserver(() => this.updateReadMoreButtons());
        this.quoteElements.forEach(quoteElement => this.quoteResizeObserver.observe(quoteElement));
        document.fonts?.ready.then(() => this.updateReadMoreButtons());
      }

      getReadMoreButtonElement(quoteElement) {
        return quoteElement.parentElement.querySelector('[data-testimonials-read-more]');
      }

      isQuoteOverflowing(quoteElement) {
        const quoteStyles = getComputedStyle(quoteElement);
        const maxLines = Number(quoteStyles.getPropertyValue('--quote-max-lines'));
        const lineHeight = parseFloat(quoteStyles.lineHeight);

        return quoteElement.scrollHeight > Math.ceil(lineHeight * maxLines) + 1;
      }

      updateReadMoreButtons() {
        this.quoteElements.forEach(quoteElement => {
          const readMoreButtonElement = this.getReadMoreButtonElement(quoteElement);
          if (readMoreButtonElement) readMoreButtonElement.hidden = !this.isQuoteOverflowing(quoteElement);
        });
      }

      toggleQuote(quoteElement) {
        const readMoreButtonElement = this.getReadMoreButtonElement(quoteElement);
        const isExpanded = quoteElement.classList.toggle('testimonials-slider__quote--expanded');

        readMoreButtonElement.setAttribute('aria-expanded', String(isExpanded));
        readMoreButtonElement.textContent = isExpanded
          ? readMoreButtonElement.dataset.readLessText
          : readMoreButtonElement.dataset.readMoreText;

        this.resizeSlider();
      }

      resizeSlider() {
        if (!this.flickityInstance) return;

        this.classList.add('testimonials-slider--measuring');
        this.flickityInstance.resize();
        this.classList.remove('testimonials-slider--measuring');
      }

      initSlider() {
        if (!this.sliderElement.classList.contains('flickityt4s-enabled')) {
          this.sliderElement.flickityt4s = new T4SThemeSP.Carousel(this.sliderElement);
        }

        this.flickityInstance = this.getFlickityInstance();
        if (!this.flickityInstance) return;

        this.previousButtonElement?.addEventListener('click', () => this.flickityInstance.previous());
        this.nextButtonElement?.addEventListener('click', () => this.flickityInstance.next());
        this.dotElements.forEach(dotElement => {
          dotElement.addEventListener('click', () => this.flickityInstance.select(Number(dotElement.dataset.testimonialsDot)));
        });

        this.addEventListener('shopify:block:select', this.selectEditorBlock.bind(this));
        this.flickityInstance.on('select', this.updateControls.bind(this));
        this.flickityInstance.on('resize', this.updateControls.bind(this));
        this.updateControls();
      }

      getFlickityInstance() {
        return window.Flickityt4s?.data(this.sliderElement) || window.jQuery?.(this.sliderElement).data('flickityt4s');
      }

      selectEditorBlock(blockSelectEvent) {
        const slideElement = blockSelectEvent.target.closest('[data-testimonials-slide]');
        if (slideElement) this.flickityInstance.selectCell(slideElement, false, true);
      }

      updateControls() {
        const selectedIndex = this.flickityInstance.selectedIndex;
        const lastSlideIndex = this.flickityInstance.slides.length - 1;
        const hasMultipleSlides = lastSlideIndex > 0;

        [this.previousButtonElement, this.nextButtonElement].forEach(buttonElement => {
          if (buttonElement) buttonElement.hidden = !hasMultipleSlides;
        });

        if (this.previousButtonElement) this.previousButtonElement.disabled = selectedIndex === 0;
        if (this.nextButtonElement) this.nextButtonElement.disabled = selectedIndex === lastSlideIndex;

        this.dotElements.forEach((dotElement, dotIndex) => {
          dotElement.classList.toggle('testimonials-slider__dot--active', dotIndex === selectedIndex);
          dotElement.hidden = !hasMultipleSlides || dotIndex > lastSlideIndex;
        });
      }
    }
  );
}
